export default function Aida() {
  return (
    <div>
      <p>
        It combines the power of generative AI with the capabilities of the DISGENET REST API. You can ask
        questions in natural language and the assistant will translate them to structured queries to the
        database exploiting all the features available in DISGENET, and summarize the main results for you.
        The DISGENET AI assistant lowers the barrier to access DISGENET for users with no programming skills
        and no knowledge about DISGENET data schema. Try it{' '}
        <a href="/Assistant" target="_blank">
          here
        </a>
        .
      </p>
    </div>
  );
}
